/**
 * @file A goal read's progress: the set progress through `children`, else
 * its state, a spinner labelled `loadingLabel`, "No goal set", a dash for a
 * goal not visible at this scope, or the read's error. Consumers:
 * `AnalyticsOverviewTiles`, both Overview credit tables and
 * `HomeAnalyticsTiles`.
 * A missing goal never renders as zero.
 */
import { FC, ReactNode } from 'react';
import { Spin, Tooltip, Typography } from 'antd';

import type { AnalyticsGoalReadProgress, GoalProgress } from '@/analytics';

const { Text } = Typography;

export const AnalyticsGoalState: FC<{
  progress: AnalyticsGoalReadProgress;
  loadingLabel: string;
  children: (progress: GoalProgress) => ReactNode;
}> = ({ progress, loadingLabel, children }) => {
  switch (progress.status) {
    case 'loading':
      return <Spin size="small" aria-label={loadingLabel} />;
    case 'noGoal':
      return <Text type="secondary">No goal set</Text>;
    case 'denied':
      return (
        <Tooltip title="Goal not visible at this scope">
          <Text type="secondary">—</Text>
        </Tooltip>
      );
    case 'failed':
      return <Text type="danger">{progress.message}</Text>;
    case 'set':
      return children(progress.progress);
  }
};
